import { Button } from '@exam-prep/ui';
import { Shell } from './ui/Login';

/**
 * The 401 screen: shown instead of an empty page when a signed-in session stops working
 * (expired, revoked, or signed out in another tab). "Sign in" opens the sign-in form; "Go home"
 * lands on Home after signing in again.
 */
export function UnauthorizedPage({
  onSignIn,
  onHome,
}: {
  onSignIn: () => void;
  onHome: () => void;
}) {
  return (
    <Shell
      title="Sign in to continue"
      description="You're not signed in, or your session has expired. Sign in again to pick up where you left off."
    >
      <div className="flex flex-col gap-3">
        <p className="text-xs font-semibold tracking-[0.2em] text-muted-foreground uppercase">
          401 · Not signed in
        </p>
        <Button onClick={onSignIn}>Sign in</Button>
        <a
          href="#/home"
          className="text-center text-sm text-muted-foreground underline-offset-4 hover:underline"
          onClick={onHome}
        >
          Go home
        </a>
      </div>
    </Shell>
  );
}
